import { useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
export const useInvoicesDigest = function useInvoicesDigest() {
    let { refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { data, isLoading, isBackgroundLoading, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.InvoicesDigest
        ],
        queryFn: ()=>api.invoice.getDigestFromQuery(),
        refreshOnHookMount
    });
    return {
        invoicesDigest: data,
        isLoading,
        isBackgroundLoading,
        refresh,
        error
    };
};
